import util from '@/util.js'

export default {
  getProduct: function (productId, cb) {
    util.adminApiHandler('post', `/goods/findbyid/${productId}`, null, cb)
  },
  getGallery: function (productId, cb) {
    var data = {
      goodsId: productId,
      sort: 'sortOrder',
      desc: false
    }
    util.adminApiHandler('post', '/goodsGallery/findByCondition', data, cb)
  },
  getAttrs: function (productId, cb) {
    util.adminApiHandler('post', `/goodsAttr/findbygoods/${productId}`, null, cb)
  },
  getAttrGallery: function (ids, cb) {
    var data = { ids }
    util.apiHandler('post', '/gallery/findByIds', data, cb)
  },
  getBrandProducts: function (brandId, filter, cb) {
    var data = { brand_id: Number(brandId), is_on_sale: true }
    if (filter) {
      data.page = Number(filter.page)
      data.count = Number(filter.limit)
    }
    util.adminApiHandler('post', '/goods/searchProductByBrand', data, cb)
  },
  getBrand: function (brandId, cb) {
    util.adminApiHandler('post', `/brand/findbyid/${brandId}`, null, cb)
  },
  getPageBlocks: function (cb) {
    var data = { sort: 'groupId', desc: false }
    util.adminApiHandler('post', '/pageBlock/findByCondition', data, cb)
  }
}
